module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.css_class,
    attrs: {
      "id": "front"
    }
  }, [_c('header-front'), _vm._v(" "), _c('animated-loader', {
    ref: "aload",
    attrs: {
      "id": "loader"
    },
    on: {
      "close": _vm.onLoaderClose
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('transition', {
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "enter-cancelled": _vm.enterCancelled,
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave,
      "leave-cancelled": _vm.leaveCancelled
    }
  }, [_c('router-view', {
    ref: "routerView",
    on: {
      "reload": _vm.onReload,
      "loaded": _vm.onLoaded,
      "cssclass": _vm.onClass
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bg"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b4086c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/front/Front.vue
// module id = 256
// module chunks = 1